import { createSelector } from 'reselect';

const selectOrganization = (state) => state.organization;

export const memoizedOrganizationSelector = createSelector(
    [selectOrganization],
    (organization) =>
        organization.map((data) => ({
            id: data.id,
            to: data.to,
            label: data.label,
            img: data.img
        }))
);
